// extracted by mini-css-extract-plugin
export var orderSummary = "_qj-0";
export var showMoreLessButton = "_qj-1";